import { trigger, style, animate, transition, keyframes } from '@angular/animations';


export const Fade = trigger('fade', [
    transition(':enter', [
        style({ opacity: 0}),
        animate('300ms', style({ opacity: 1 })),
    ]),
    transition(':leave', [
        style({ border: '10px solid red' }),
        animate('500ms', style({ opacity: 0 }))
    ]),
]);

export const FadeSlideinOut = trigger('fadeSlideInOut', [
    transition(':enter', [
        style(
            {
                opacity: 0,
                transform: 'translateX(100%)',
            }
        ),
        animate(
            '500ms ease-in',
            style({
                opacity: 1,
                transform: 'translateX(0px)',
            })
        ),
    ]),
    transition('* => void', [
        style({
            transform: 'translateX(100%)',
            border: '100px solid red'
            //opacity: 1
        }),
        animate(
            '1s ease-out',
            style({ 
                transform: 'translateX(100%)',
                //opacity: 0,
            })),
    ]),
]);
